// import React, { useEffect, useRef, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { WebService } from "../../Services/WebService";
// import { PageInfo } from "../PageInfo";
// import { Button, Card, Form, Modal, Alert } from "react-bootstrap";
// import { StandardConst } from "../../Services/StandardConst";
// import { WSSuccessAlert, WSErrorAlert, WSWarningAlert } from "../../Services/WSAlert";
// import { AttachFileOutlined } from "@mui/icons-material";
// import ActionButton from "../../Services/ActionButton";

// const EmployeeDocumentView = () => {
//   const { documentId } = useParams();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [documentData, setDocumentData] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [showSignatureModal, setShowSignatureModal] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [acknowledgmentChecked, setAcknowledgmentChecked] = useState(false);
//   const [signatureFile, setSignatureFile] = useState(null);
//   const [coordinates, setCoordinates] = useState({ latitude: null, longitude: null });
//   const UserInfo = useSelector((s) => s.auth.BasicInfo ?? {});

//   PageInfo({ pageTitle: "View Document" });

//   const getCoordinates = async () => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const { latitude, longitude } = position.coords;
//           setCoordinates({ latitude, longitude });
//         },
//         (error) => {
//           WSWarningAlert("", "Location is required for signature.");
//         }
//       );
//     } else {
//       WSWarningAlert("", "Geolocation is not supported by this browser.");
//     }
//   };

//   useEffect(() => {
//     if (documentId) {
//       fetchDocumentDetails();
//       getCoordinates();
//     }
//   }, [documentId]);

//   const fetchDocumentDetails = async () => {
//     setIsLoading(true);
//     try {
//       const result = await WebService({
//         endPoint: `Document/GetEmployeeDocument/${documentId}?employeeId=${UserInfo.EmployeeId}`,
//         method: "GET",
//         dispatch,
//       });

//       if (result?.result) {
//         setDocumentData(result.result);
//       }
//     } catch (error) {
//       console.error("Error fetching document:", error);
//       WSErrorAlert("", "Failed to load document");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleOpenSignatureModal = () => {
//     if (documentData?.RequireAcknowledgment && !acknowledgmentChecked) {
//       WSErrorAlert("", "Please acknowledge the document first");
//       return;
//     }
    
//     // Check location if signature is required
//     if (documentData?.RequireSignature) {
//       if (!coordinates.latitude || !coordinates.longitude) {
//         WSWarningAlert("", "Location is required for signature. Please enable location access.");
//         getCoordinates();
//         return;
//       }
//     }
    
//     setShowSignatureModal(true);
//   };

//   const handleCloseSignatureModal = () => {
//     setShowSignatureModal(false);
//     setSignatureFile(null);
//   };

//   const handleSubmitDocument = async () => {
//     // Validate acknowledgment if required
//     if (documentData?.RequireAcknowledgment && !acknowledgmentChecked) {
//       WSErrorAlert("", "Please acknowledge the document");
//       return;
//     }

//     // Validate signature file if required
//     if (documentData?.RequireSignature && !signatureFile) {
//       WSErrorAlert("", "Please attach your signed document");
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       let fileDetails = null;

//       // Upload the signature file if provided
//       if (signatureFile) {
//         fileDetails = await WebService({
//           endPoint: "upload/File",
//           body: signatureFile,
//           isFile: true,
//           dispatch,
//         });
//       }

//       // Prepare submission data
//       const updateData = {
//         BroadcastDocumentId: documentId,
//         EmployeeId: UserInfo.UserId,
//         IsAcknowledged: acknowledgmentChecked,
//         SignDateTimestamp: new Date(),
//         SignedDocumentFilePath: fileDetails?.filename || null,
//         Location: JSON.stringify(coordinates),
//       };

//       const result = await WebService({
//         endPoint: `Document/SubmitEmployeeDocument`,
//         method: "POST",
//         body: updateData,
//         dispatch,
//       });

//       if (result?.isSuccess) {
//         WSSuccessAlert("", `Document '${documentData.Title}' has been signed successfully!`);
//         handleCloseSignatureModal();
        
//         // Send notification
//         await WebService({
//           endPoint: `Document/SendNotification`,
//           method: "POST",
//           body: {
//             BroadcastDocumentId: documentId,
//             EmployeeId: UserInfo.UserId,
//           },
//           dispatch,
//         });

//         setTimeout(() => {
//           navigate("/MyDocuments");
//         }, 1500);
//       }
//     } catch (error) {
//       console.error("Error submitting document:", error);
//       WSErrorAlert("", "Failed to submit document");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleSimpleAcknowledgment = async () => {
//     setIsSubmitting(true);

//     try {
//       const result = await WebService({
//         endPoint: `Document/AcknowledgeDocument`,
//         method: "POST",
//         body: {
//           BroadcastDocumentId: documentId,
//           EmployeeId: UserInfo.UserId,
//         },
//         dispatch,
//       });

//       if (result?.isSuccess) {
//         WSSuccessAlert("", "Document acknowledged successfully!");
//         setTimeout(() => {
//           navigate("/MyDocuments");
//         }, 1500);
//       }
//     } catch (error) {
//       console.error("Error acknowledging document:", error);
//       WSErrorAlert("", "Failed to acknowledge document");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (isLoading) {
//     return (
//       <div className="text-center py-5">
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//         <p className="mt-3">Loading document...</p>
//       </div>
//     );
//   }

//   if (!documentData) {
//     return (
//       <Alert variant="warning" className="m-3">
//         Document not found or you don't have access to view this document.
//       </Alert>
//     );
//   }

//   const isAlreadySubmitted = documentData.Status === "Acknowledged" || documentData.Status === "Signed";

//   return (
//     <div className="container-fluid py-4">
//       <Card className="shadow-sm">
//         <Card.Header className="bg-primary text-white">
//           <div className="d-flex justify-content-between align-items-center">
//             <h4 className="mb-0">{documentData.Title}</h4>
//             <Button 
//               variant="light" 
//               size="sm" 
//               onClick={() => navigate("/MyDocuments")}
//             >
//               ← Back to My Documents
//             </Button>
//           </div>
//         </Card.Header>

//         <Card.Body>
//           {/* Document Information */}
//           <div className="row mb-4">
//             <div className="col-md-6">
//               <p className="mb-2">
//                 <strong>Sent By:</strong> {documentData.CreaterName}
//               </p>
//               <p className="mb-2">
//                 <strong>Sent On:</strong> {new Date(documentData.SentAt).toLocaleString()}
//               </p>
//             </div>
//             <div className="col-md-6">
//               <p className="mb-2">
//                 <strong>Status:</strong>{" "}
//                 <span className={`badge ${isAlreadySubmitted ? 'bg-success' : 'bg-warning'}`}>
//                   {documentData.Status || "Pending"}
//                 </span>
//               </p>
//               {documentData.AcknowledgedAt && (
//                 <p className="mb-2">
//                   <strong>Acknowledged On:</strong> {new Date(documentData.AcknowledgedAt).toLocaleString()}
//                 </p>
//               )}
//             </div>
//           </div>

//           {/* Label/Description */}
//           {documentData.Label && (
//             <Alert variant="info" className="mb-4">
//               <strong>Instructions:</strong>
//               <p className="mb-0 mt-2">{documentData.Label}</p>
//             </Alert>
//           )}

//           {/* Already Submitted Message */}
//           {isAlreadySubmitted && (
//             <Alert variant="success" className="mb-4">
//               <strong>✓ Document Submitted</strong>
//               <p className="mb-0 mt-2">
//                 You have already {documentData.RequireSignature ? 'signed' : 'acknowledged'} this document.
//               </p>
//             </Alert>
//           )}

//           {/* Document Viewer */}
//           <div className="mb-4">
//             <h5 className="mb-3">Document Preview:</h5>
//             <div className="border rounded" style={{ height: '600px' }}>
//               <iframe
//                 src={`${StandardConst.apiBaseUrl}/uploads/${documentData.DocumentPath}`}
//                 width="100%"
//                 height="100%"
//                 style={{ border: 'none' }}
//                 title="Document Preview"
//               />
//             </div>
//             <div className="text-center mt-3">
//               <Button
//                 variant="outline-primary"
//                 onClick={() => window.open(`${StandardConst.apiBaseUrl}/${documentData.DocumentPath}`, "_blank")}
//               >
//                 📥 Download Document
//               </Button>
//             </div>
//           </div>

//           {/* Action Section - Only if not already submitted */}
//           {!isAlreadySubmitted && (
//             <Card className="bg-light">
//               <Card.Body>
//                 <h5 className="mb-3">Action Required:</h5>

//                 {/* Acknowledgment Checkbox */}
//                 {documentData.RequireAcknowledgment && (
//                   <Form.Group className="mb-3">
//                     <Form.Check
//                       type="checkbox"
//                       id="acknowledgment"
//                       label="I acknowledge that I have read and understood this document"
//                       checked={acknowledgmentChecked}
//                       onChange={(e) => setAcknowledgmentChecked(e.target.checked)}
//                       disabled={isSubmitting}
//                     />
//                   </Form.Group>
//                 )}

//                 {/* Action Buttons */}
//                 <div className="d-flex gap-2">
//                   {documentData.RequireSignature ? (
//                     <>
//                       <Button
//                         variant="primary"
//                         onClick={handleOpenSignatureModal}
//                         disabled={isSubmitting || (documentData.RequireAcknowledgment && !acknowledgmentChecked)}
//                       >
//                         {isSubmitting ? "Submitting..." : "✍️ Sign Document"}
//                       </Button>
//                       {documentData.RequireAcknowledgment && !acknowledgmentChecked && (
//                         <small className="text-muted align-self-center">
//                           Please acknowledge first to proceed
//                         </small>
//                       )}
//                     </>
//                   ) : documentData.RequireAcknowledgment ? (
//                     <Button
//                       variant="success"
//                       onClick={handleSimpleAcknowledgment}
//                       disabled={isSubmitting || !acknowledgmentChecked}
//                     >
//                       {isSubmitting ? "Submitting..." : "✓ Submit Acknowledgment"}
//                     </Button>
//                   ) : (
//                     <Button
//                       variant="success"
//                       onClick={handleSimpleAcknowledgment}
//                       disabled={isSubmitting}
//                     >
//                       {isSubmitting ? "Submitting..." : "✓ Mark as Read"}
//                     </Button>
//                   )}
//                 </div>

//                 {documentData.RequireSignature && (
//                   <Alert variant="warning" className="mt-3 mb-0">
//                     <strong>⚠️ Signature Required:</strong> You must attach your signed document to complete the submission.
//                   </Alert>
//                 )}
//               </Card.Body>
//             </Card>
//           )}
//         </Card.Body>
//       </Card>

//       {/* Signature Modal */}
//       <Modal
//         show={showSignatureModal}
//         onHide={handleCloseSignatureModal}
//         backdrop="static"
//         keyboard={false}
//         centered
//       >
//         <Modal.Body>
//           <div
//             className="swal2-icon swal2-warning swal2-icon-show mt-0"
//             style={{ display: "flex" }}
//           >
//             <div className="swal2-icon-content">!</div>
//           </div>
//           <h2
//             className="swal2-title"
//             id="swal2-title"
//             style={{ display: "block", color: "#545454" }}
//           >
//             Confirm Document Signing
//           </h2>
//           <div
//             className="swal2-html-container mx-0"
//             id="swal2-html-container"
//             style={{ display: "block", color: "#545454" }}
//           >
//             By clicking 'Yes, Sign it!', you confirm that you have reviewed the
//             document '{documentData?.Title}' and agree to its terms. Your location will be recorded as part of your signature. This action is
//             final and cannot be undone.
//           </div>
          
//           {documentData?.RequireSignature && (
//             <div className="d-flex justify-content-center my-3">
//               <label
//                 htmlFor="signatureFileInput"
//                 className="d-flex align-items-center gap-2 mb-2 mb-md-0"
//               >
//                 <span>
//                   {signatureFile 
//                     ? signatureFile.name 
//                     : "Attach the Signed Document (Required)"}
//                 </span>
//                 <input
//                   type="file"
//                   onChange={(e) => setSignatureFile(e.target.files[0])}
//                   className="form-control d-none"
//                   id="signatureFileInput"
//                   accept=".pdf,.jpg,.jpeg,.png"
//                 />
//                 {!signatureFile && (
//                   <span className="btn btn-outline-primary">
//                     <AttachFileOutlined />
//                   </span>
//                 )}
//               </label>
//               {signatureFile && (
//                 <ActionButton
//                   IconName="Close"
//                   IconTooltip="Remove file"
//                   onClick={() => setSignatureFile(null)}
//                 />
//               )}
//             </div>
//           )}

//           {coordinates.latitude && coordinates.longitude && (
//             <Alert variant="info" className="mt-2 mb-0">
//               <small>
//                 📍 Location: {coordinates.latitude.toFixed(6)}, {coordinates.longitude.toFixed(6)}
//               </small>
//             </Alert>
//           )}
//         </Modal.Body>
        
//         <Modal.Footer>
//           <span className="d-flex justify-content-center gap-2 w-100">
//             <Button
//               variant="secondary"
//               style={{ fontWeight: "bold" }}
//               onClick={handleCloseSignatureModal}
//               disabled={isSubmitting}
//             >
//               No, Review Again
//             </Button>
//             <Button
//               variant="primary"
//               style={{ fontWeight: "bold" }}
//               onClick={handleSubmitDocument}
//               disabled={isSubmitting || (documentData?.RequireSignature && !signatureFile)}
//             >
//               {isSubmitting ? (
//                 <>
//                   <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                   Submitting...
//                 </>
//               ) : (
//                 "Yes, Sign it!"
//               )}
//             </Button>
//           </span>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default EmployeeDocumentView;



import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { WebService } from "../../Services/WebService";
import { PageInfo } from "../PageInfo";
import { Button, Card, Form, Alert } from "react-bootstrap";
import { StandardConst } from "../../Services/StandardConst";
import { WSSuccessAlert, WSErrorAlert, WSWarningAlert } from "../../Services/WSAlert";
import BroadcastSignatureModal from "./BroadcastSignatureModal";

const EmployeeDocumentView = () => {
  const { documentId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [documentData, setDocumentData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [acknowledgmentChecked, setAcknowledgmentChecked] = useState(false);
  const [coordinates, setCoordinates] = useState({ latitude: null, longitude: null });
  const UserInfo = useSelector((s) => s.auth.BasicInfo ?? {});
  const SignModalRef = useRef();

  PageInfo({ pageTitle: "View Document" });

  const getCoordinates = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCoordinates({ latitude, longitude });
        },
        (error) => {
          WSWarningAlert("", "Location is required for signature.");
        }
      );
    } else {
      WSWarningAlert("", "Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    if (documentId) {
      fetchDocumentDetails();
      getCoordinates();
    }
  }, [documentId]);

  const fetchDocumentDetails = async () => {
    setIsLoading(true);
    try {
      const result = await WebService({
        endPoint: `Document/GetEmployeeDocument/${documentId}?employeeId=${UserInfo.EmployeeId}`,
        method: "GET",
        dispatch,
      });

      if (result?.result) {
        setDocumentData(result.result);
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      WSErrorAlert("", "Failed to load document");
    } finally {
      setIsLoading(false);
    }
  };

  const fnSignModal = async () => {
    if (documentData?.RequireAcknowledgment && !acknowledgmentChecked) {
      WSErrorAlert("", "Please acknowledge the document first");
      return;
    }
    
    if (!coordinates.latitude || !coordinates.longitude) {
      WSWarningAlert("", "Location is required for signature. Please enable location access.");
      getCoordinates();
      return;
    }
    
    await SignModalRef.current.openModal(documentData);
  };

  const handleSimpleAcknowledgment = async () => {
    setIsSubmitting(true);

    try {
      const data = {
        Location: JSON.stringify(coordinates),
        SignDateTimestamp: new Date(),
      };

      await WebService({
        endPoint: `Document/BroadcastDocumentRecipientAchno?BroadcastDocumentId=${documentId}&EmployeeId=${UserInfo.EmployeeId}`,
        method: "PUT",
        body: data,
        dispatch,
      });

      WSSuccessAlert("", `Document '${documentData.Title}' acknowledged successfully!`);
      console.log(documentData,'docs data');
      // Send notification
      await WebService({
        endPoint: `Document/SendNotification`,
        method: "POST",
        body: {
          BroadcastDocumentId: documentId,
          EmployeeId: UserInfo.EmployeeId,
        },
        dispatch,
      });

      setTimeout(() => {
        navigate("/MyBroadcastDocuments");
      }, 1500);
    } catch (error) {
      console.error("Error acknowledging document:", error);
      WSErrorAlert("", "Failed to acknowledge document");
    } finally {
      setIsSubmitting(false);
    }
  };

  function beautifyLocalTime(utcTimestamp) {
    if (!utcTimestamp) return '-';
    const utcDate = new Date(utcTimestamp);
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
    };
    return new Intl.DateTimeFormat(undefined, options).format(utcDate);
  }

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Loading document...</p>
      </div>
    );
  }

  if (!documentData) {
    return (
      <Alert variant="warning" className="m-3">
        Document not found or you don't have access to view this document.
      </Alert>
    );
  }

  const isAlreadySubmitted = documentData.Status === "Acknowledged" || documentData.Status === "Signed";

  return (
    <div className="container-fluid py-4">
      <Card className="shadow-sm">
        <Card.Header className="bg-primary text-white">
          <div className="d-flex justify-content-between align-items-center">
            <h4 className="mb-0">{documentData.Title}</h4>
            <Button 
              variant="light" 
              size="sm" 
              onClick={() => navigate("/MyBroadcastDocuments")}
            >
              ← Back to My Documents
            </Button>
          </div>
        </Card.Header>

        <Card.Body>
          {/* Document Information */}
          <div className="row mb-4">
            <div className="col-md-6">
              <p className="mb-2">
                <strong>Sent By:</strong> {documentData.CreaterName}
              </p>
              <p className="mb-2">
                <strong>Sent On:</strong> {beautifyLocalTime(documentData.SentAt)}
              </p>
            </div>
            <div className="col-md-6">
              <p className="mb-2">
                <strong>Status:</strong>{" "}
                <span className={`badge ${isAlreadySubmitted ? 'bg-success' : 'bg-warning'}`}>
                  {documentData.Status == 'Sent' ? 'Pending' : documentData.Status || "Pending"}
                </span>
              </p>
              {documentData.AcknowledgedAt && (
                <p className="mb-2">
                  <strong>Acknowledged On:</strong> {beautifyLocalTime(documentData.AcknowledgedAt)}
                </p>
              )}
              {documentData.SignedAt && (
                <p className="mb-2">
                  <strong>Signed On:</strong> {beautifyLocalTime(documentData.SignedAt)}
                </p>
              )}
            </div>
          </div>

          {/* Label/Description */}
          {documentData.Label && (
            <Alert variant="info" className="mb-4">
              <strong>Instructions:</strong>
              <p className="mb-0 mt-2">{documentData.Label}</p>
            </Alert>
          )}

          {/* Already Submitted Message */}
          {isAlreadySubmitted && (
            <Alert variant="success" className="mb-4">
              <strong>✓ Document Submitted</strong>
              <p className="mb-0 mt-2">
                You have already {documentData.RequireSignature ? 'signed' : 'acknowledged'} this document.
              </p>
            </Alert>
          )}

          {/* Document Viewer */}
          {/* <div className="mb-4">
            <h5 className="mb-3">Document Preview:</h5>
            <div className="border rounded" style={{ height: '600px' }}>
              <iframe
                src={`${StandardConst.apiBaseUrl}/uploads/${documentData.DocumentPath}`}
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                title="Document Preview"
              />
            </div>
            <div className="text-center mt-3">
              <Button
                variant="outline-primary"
                onClick={() => window.open(`${StandardConst.apiBaseUrl}/uploads/${documentData.DocumentPath}`, "_blank")}
              >
                📥 Download Document
              </Button>
            </div>
          </div> */}
          <div className="mb-4">
  {/* <h5 className="mb-3">Document Preview:</h5>
  <div className="border rounded" style={{ height: '600px' }}>
    <iframe
      // src={
      //   documentData.DocumentPath.toLowerCase().endsWith('.pdf')
      //     ? `${StandardConst.apiBaseUrl}/uploads/${documentData.DocumentPath}`
      //     : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
      //         `${StandardConst.apiBaseUrl}/uploads/${documentData.DocumentPath}`
      //       )}`
      // }
      src={
  documentData.DocumentPath.toLowerCase().endsWith('.pdf')
    ? `${StandardConst.apiBaseUrl}/uploads/${documentData.DocumentPath}`
    : `https://docs.google.com/gview?url=${encodeURIComponent(
        `${StandardConst.apiBaseUrl}/uploads/${documentData.DocumentPath}`
      )}&embedded=true`
}
      width="100%"
      height="100%"
      style={{ border: 'none' }}
      title="Document Preview"
    />
  </div> */}
  <div className="text-center mt-3">
    <Button
      variant="outline-primary"
      onClick={() => window.open(`${StandardConst.apiBaseUrl}/uploads/${documentData.DocumentPath}`, "_blank")}
    >
      📥 Download Document
    </Button>
  </div>
</div>

          {/* Action Section - Only if not already submitted */}
          {!isAlreadySubmitted && (
            <Card className="bg-light">
              <Card.Body>
                <h5 className="mb-3">Action Required:</h5>

                {/* Acknowledgment Checkbox */}
                {documentData.RequireAcknowledgment === 1  && (
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      id="acknowledgment"
                      label="I acknowledge that I have read and understood this document"
                      checked={acknowledgmentChecked}
                      onChange={(e) => setAcknowledgmentChecked(e.target.checked)}
                      disabled={isSubmitting}
                    />
                  </Form.Group>
                )}

                {/* Action Buttons */}
                <div className="d-flex gap-2">
                  {documentData.RequireSignature ? (
                    <>
                      <Button
                        variant="primary"
                        onClick={fnSignModal}
                        disabled={isSubmitting || (documentData.RequireAcknowledgment && !acknowledgmentChecked)}
                      >
                        {isSubmitting ? "Submitting..." : "✍️ Sign Document"}
                      </Button>
                      {documentData.RequireAcknowledgment === 1 && !acknowledgmentChecked && (
                        <small className="text-muted align-self-center">
                          Please acknowledge first to proceed
                        </small>
                      )}
                    </>
                  ) : documentData.RequireAcknowledgment ? (
                    <Button
                      variant="success"
                      onClick={handleSimpleAcknowledgment}
                      disabled={isSubmitting || !acknowledgmentChecked}
                    >
                      {isSubmitting ? "Submitting..." : "✓ Submit Acknowledgment"}
                    </Button>
                  ) : (
                    <Button
                      variant="success"
                      onClick={handleSimpleAcknowledgment}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "✓ Mark as Read"}
                    </Button>
                  )}
                </div>

                {documentData.RequireSignature === 1 && (
                  <Alert variant="warning" className="mt-3 mb-0">
                    <strong>⚠️ Signature Required:</strong> You must digitally sign this document to complete the submission. Your location will be recorded.
                  </Alert>
                )}
              </Card.Body>
            </Card>
          )}
        </Card.Body>
      </Card>

      {/* Signature Modal - Reusing existing component pattern */}
      <BroadcastSignatureModal
        callBackEvent={async () => {
          await fetchDocumentDetails();
          setTimeout(() => {
            navigate("/MyBroadcastDocuments");
          }, 1500);
        }}
        ref={SignModalRef}
      />
    </div>
  );
};

export default EmployeeDocumentView;